import {useCallback, useEffect, useRef, useState} from "react";
import sqftEventManager from "../bvcomponents/sqft/components/canvas/store/sqftEventManager";
import {checkIfLookFeaturesReceived} from "../api/look-api";
import store from "../store";
import {updateNavigationCount} from "../actions/lookFunctions";

export const usePrevious = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

export const useIsMounted = () => {
  const isMountedRef = useRef(true);
  const isMounted = useCallback(() => isMountedRef.current, []);

  useEffect(() => {
    return () => void (isMountedRef.current = false);
  }, []);

  return isMounted;
}

export const IsMountedComponent = (props) => {
  const {children} = props;
  const isMountedComponent = useIsMounted();
  return typeof children === 'function' ? children(isMountedComponent) : children;
}

export const useOutsideClick = (ref, callback, useSQFTCanvas = false) => {
  const handleClick = e => {
    if (ref.current && !ref.current.contains(e.target)) {
      callback(e);
    }
  };

  const handleClickThroughCanvasEvents = (mousePos, e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      callback(e);
    }

    return false
  };

  useEffect(() => {
    if (useSQFTCanvas) {
      const objectName = {name: 'helperOutsideClickHook'};

      document.addEventListener(sqftEventManager.events.CLICK, handleClick);
      //document.addEventListener(sqftEventManager.events.TOUCH_START, handleClick);
      sqftEventManager.addEvent(
        sqftEventManager.events.MOUSE_DOWN,
        handleClickThroughCanvasEvents,
        objectName,
        sqftEventManager.priorities.OVERALL
      );

      return () => {
        if (useSQFTCanvas) {
          document.removeEventListener(sqftEventManager.events.CLICK, handleClick);
          //document.removeEventListener(sqftEventManager.events.TOUCH_START, handleClick);
          sqftEventManager.removeEvent(objectName);
        }
      };
    }
  });
};

export const useProgressiveImage = (imageUrl) => {

  const [thumbnailLoaded, setThumbnailLoaded] = useState(false)
  const isMounted = useIsMounted();

  useEffect(() => {
    const image = new Image();
    image.onload = () => {
      if (isMounted()) {
        setThumbnailLoaded(true)
      }
    };
    image.onerror = () => {
      if (isMounted()) {
        setThumbnailLoaded(true)
      }
    };
    try {
      image.src = imageUrl;
      if (image.complete) {
        if (isMounted()) {
          setThumbnailLoaded(true)
        }
      }
    } catch (e) {
      if (isMounted()) {
        setThumbnailLoaded(true)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageUrl])

  return thumbnailLoaded
}

let requestInProgressTimeoutId = null;

export const useFeaturesChecker = (featureGroup, visualizersLoadedLength) => {

  const [featuresLoaded, setFeaturesLoaded] = useState(featureGroup ? featureGroup.allFeaturesReceived : false)
  const isMounted = useIsMounted();

  const checkFeatures = () => {
    if (!featureGroup.allFeaturesReceived) {
      if (featureGroup.requestInProgress) {
        const callRecursiveFeaturesCheck = () => {
          console.log("callRecursiveFeaturesCheck", featureGroup);
          if (featureGroup.allFeaturesReceived) {
            clearTimeout(requestInProgressTimeoutId);
            store.dispatch(updateNavigationCount());
            if (isMounted()) {
              setFeaturesLoaded(true)
            }
            return
          }
          requestInProgressTimeoutId = setTimeout(callRecursiveFeaturesCheck, 1000); // check every second for response
        };
        setTimeout(callRecursiveFeaturesCheck, 1000); // first time
      } else {
        checkIfLookFeaturesReceived(featureGroup).then(() => {
          // store.dispatch(updateFeatureGroupCount());
          store.dispatch(updateNavigationCount());
          if (isMounted()) {
            setFeaturesLoaded(true)
          }
        })
      }
    }
  }

  useEffect(() => {
    if (!featureGroup || !visualizersLoadedLength) {
      return false
    }
    if (!featureGroup.allFeaturesReceived) {
      checkFeatures()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [featureGroup, visualizersLoadedLength])

  return featuresLoaded
}
